const getHostname = (url) => {
    // use URL constructor and return hostname
    return new URL(url).hostname;
}

let host = window.location.origin;
let finalHostName = getHostname(host);

const ENV = {
    base: `https://${finalHostName}/api`,
   // base: "https://taskgpt.taskus.com/api",
    botbase: "https://taskgpt.taskus.com/",
    websocket_url: "wss://taskgpt.taskus.com/ws/process_file_for_embeddings",
    websocket_receiver: "taskgpt.taskus",
    websocket_environment: "prod",
    product_title: "",
    cfFlag: "true",
    authUser: "prod",
    ping: {
      client_id: "c21083db-e0c4-4835-97ec-5f8bf6e7551b",
      auth_url:
        "https://sso.connect.pingidentity.com/sso/as/authorization.oauth2",
      redirect_uri: "https://taskgpt.taskus.com",
    },
    smartFloBaseUrl: "https://smartflo.taskus.com",
    smartFloApiBaseUrl: "https://smartflo.taskus.com/api"


};

export const getEnv = () => {

  return ENV ;
};

